import { REDEEM_CODE } from "modules/constants";

// ------------------------------------
// Actions
// ------------------------------------
export function redeem(value) {
  return {
    type: REDEEM_CODE,
    payload: value
  };
}

export const actions = {
  redeem
};
